/**
 * Created by Ning Jiang on 6/28/2018.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IScreenViewConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {BonusGameScreenView} from "../BonusGameScreenView";

export class BonusGameOutroView extends BonusGameScreenView {

    constructor(config:IScreenViewConfig, autoClose:boolean = false) {
        super(config, autoClose);
    }

    protected getNewMode():string {
        return GameMode.NORMAL;
    }

    protected startPresentation(data?:ParsedServerData, onShowComplete?:() => void):void {
        super.startPresentation(data, onShowComplete);
    }
}